import { AdminUpdateAreaDTO } from '../models/ListAreas'
import { TicketRepository } from '../repositories/TicketRepository'

export function AdminUpdateAreaCase(ticketRepository: TicketRepository) {
  return async function ({
    areaId,
    data
  }: {
    areaId: string
    data: AdminUpdateAreaDTO
  }) {
    return await ticketRepository.adminUpdateArea({ areaId, data })
  }
}
